import { render } from "./ViewCARelatedPayments.vue?vue&type=template&id=66d60c70"
import script from "./ViewCARelatedPayments.vue?vue&type=script&lang=js"
export * from "./ViewCARelatedPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__